// src/components/auth/RoleBasedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingSpinner from '../common/LoadingSpinner';

/**
 * Simple RoleBasedRoute Component
 * Only renders children if user has the required role
 */
const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  // No user logged in
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Check if user's role is in the allowed roles
  const isAllowed = allowedRoles.includes(user.role);

  // User doesn't have the required role
  if (!isAllowed) {
    // Redirect to user's default dashboard
    const defaultPath = `/${user.role}`;
    return <Navigate to={defaultPath} replace />;
  }

  // User is authorized - render the protected content
  return children;
};

export default RoleBasedRoute;